module.exports = __webpack_public_path__ + "static/media/cps_new.da02f855.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cps_new.svg
// module id = 1598
// module chunks = 0